import { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { useQueryParam } from 'use-query-params';

export interface OverlayRouteParams {
  organizerId?: number;
  deviceId?: number;
  token?: string;
  /**
   * Готовый для показа текст: чего в адресе не хватает. `undefined`, когда всё на месте.
   * Оверлей и панель открываются по ссылке, вставленной в OBS или в адресную строку,
   * поэтому битую ссылку надо объяснить, а не падать исключением на белом экране.
   */
  error?: { title: string; subtitle: string };
}

const COPY_AGAIN = 'Скопируйте ссылку заново: раздел «Устройства» → строка нужного устройства → «Копировать ссылку».';

/** Разбор адреса `organizer/:organizerId/device/:deviceId/...?token=` без исключений. */
function useOverlayRouteParams(): OverlayRouteParams {
  const { organizerId: organizerIdParam, deviceId: deviceIdParam } = useParams();
  const token = useQueryParam('token')[0] as string | undefined;

  return useMemo(() => {
    const organizerId = organizerIdParam ? Number(organizerIdParam) : undefined;
    const deviceId = deviceIdParam ? Number(deviceIdParam) : undefined;

    if (organizerId === undefined || isNaN(organizerId)) {
      return { token, error: { title: 'В ссылке не указан организатор', subtitle: COPY_AGAIN } };
    }

    if (deviceId === undefined || isNaN(deviceId)) {
      return { organizerId, token, error: { title: 'В ссылке не указано устройство', subtitle: COPY_AGAIN } };
    }

    if (!token) {
      return {
        organizerId,
        deviceId,
        error: { title: 'В ссылке нет токена авторизации', subtitle: COPY_AGAIN },
      };
    }

    return { organizerId, deviceId, token };
  }, [organizerIdParam, deviceIdParam, token]);
}

export default useOverlayRouteParams;
